<template>
  <data-list
    ref="dataList"
    class="content"
    url="/admin/memorial-tablet-order"
    query="&expand=tabletBlockItem.tabletBlock.tabletRegion&sort=-id"
    entity-name="供灯订单"
    add-btn="龛位供奉"
    hide-edit
    hide-delete
    add-route="TabletNicheOverview"
    :default-query="defaultQuery"
    :custom-url="customUrl"
    :deal-list="dealOrderList"
    :action="action"
    :columns="columns"
    @detail="showDetail"
  >
    <template v-slot:button="{ form }">
      <a-button @click="exportData(form)" :loading="exporting">
        {{ exporting ? "正在导出" : "导出数据" }}
      </a-button>
    </template>
    <template v-slot:action="{ item }">
      <!-- <span class="txt-btn" @click.stop="renewal(item)" v-if="item.canRenewal">续供</span> -->
      <span
        class="txt-btn danger"
        @click.stop="refundOrder(item)"
        v-if="item.status == 1"
      >
        退款
      </span>
      <span
        class="txt-btn"
        @click.stop="cancelOrder(item)"
        v-if="item.status == 0"
      >
        取消订单
      </span>
    </template>
    <template v-slot:query="{ form }">
      <a-form-model-item label="">
        <a-select
          style="width: 180px"
          placeholder="选择订单状态筛选"
          :options="statusList"
          allow-clear
          v-model="form.status"
          @change="updateList"
        >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="">
        <a-select
          style="width: 180px"
          placeholder="选择订单来源筛选"
          :options="catOptions"
          allow-clear
          v-model="form.cat"
          @change="updateList"
        >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="下单时间">
        <a-range-picker
          v-model="form.range"
          @change="updateList"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          style="width: 240px; text-align: left"
        />
      </a-form-model-item>
      <a-form-model-item label="">
        <a-input
          v-model="form.keyword"
          placeholder="输入供奉人/手机号查询"
          @keyup.enter="updateList"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item label="所属区域">
        <a-select
          style="width: 180px"
          placeholder="选择区域查询"
          allow-clear
          @change="regionChange($event, form)"
          :options="regionList"
          v-model="form.mem_tablet_region_id"
        >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="所属区块">
        <a-select
          style="width: 180px"
          placeholder="选择区块查询"
          allow-clear
          @change="updateList"
          :options="blockList"
          v-model="form.mem_tablet_block_id"
        >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="龛位编号">
        <a-input
          v-model="form.num"
          placeholder="输入龛位编号查询"
          @keyup.enter="updateList"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item label="即将到期时间" v-if="form.status == 1">
        <a-select
          style="width: 180px"
          placeholder="选择时间"
          :options="expireOptions"
          allow-clear
          v-model="form.expire_date"
          @change="updateList"
        >
        </a-select>
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>
import { downLoadBlobFile, isEmpty } from "../../common/js/tool";
import {
  orderStatusOptions,
  catOptions,
  expireOptions,
  dealNicheOrder,
  getCatText,
} from "../../common/tablet/type";

export default {
  name: "TabletOrder",
  data() {
    return {
      loading: false,
      exporting: false,
      statusList: [...orderStatusOptions],
      columns: [
        { title: "订单号", dataIndex: "order_num" },
        { title: "下单时间", dataIndex: "create_time" },
        { title: "龛位编号", dataIndex: "numText" },
        { title: "龛位价格", dataIndex: "lightPrice" },
        { title: "总金额", dataIndex: "orderPrice" },
        { title: "订单状态", dataIndex: "statusText", width: 120 },
        { title: "订单来源", dataIndex: "catText", width: 120 },
        { title: "供奉人", dataIndex: "user_name", width: 120 },
        { title: "手机号", dataIndex: "mobile", width: 180 },
        { title: "供奉时间", dataIndex: "provideTime" },
      ],
      expireOptions,
      catOptions,
      regionList: [],
      blockList: [],
    };
  },
  computed: {
    action() {
      return this.$route.meta.action;
    },
    expire_date() {
      return this.$route.query.expire_date;
    },
    today_order() {
      return this.$route.query.today_order;
    },
    defaultQuery() {
      let query;
      if (this.expire_date) {
        // 三天内到期
        query = { status: 1, expire_date: this.expire_date * 1 };
      }
      if (this.today_order) {
        const today = new Date().pattern("yyyy-MM-dd");
        const range = [`${today} 00:00:00`, `${today} 23:59:59`];
        // 今日供奉
        if (query) {
          query.status = 1;
          query.range = range;
        } else {
          query = { status: 1, range };
        }
      }
      return query;
    },
  },
  created() {
    this.getRegion();
  },
  methods: {
    getRegion() {
      this.$axios({
        url: "/admin/memorial-tablet-region",
        method: "GET",
        params: {
          pageSize: 9999,
        },
        noTempleFilter: true,
      }).then((res) => {
        this.regionList = res.data?.map((item) => {
          item.key = item.id;
          item.title = item.name;
          return item;
        });
      });
    },
    regionChange(val, form) {
      this.$set(form, "mem_tablet_block_id", undefined);
      this.getBlock();
      this.updateList();
    },
    getBlock() {
      this.$axios({
        url: "/admin/memorial-tablet-block",
        method: "GET",
        params: {
          pageSize: 9999,
        },
        noTempleFilter: true,
      }).then((res) => {
        this.blockList = res.data?.map((item) => {
          item.key = item.id;
          item.title = item.name;
          return item;
        });
      });
    },
    exportData(form) {
      if (this.exporting) return;
      this.exporting = true;
      let fileName = `${new Date().pattern("yyyy-MM-dd")}`;
      let url = "/admin/memorial-tablet-order/export";
      const params = {};
      if (form.status) {
        params.status = form.status;
      }
      if (form.range && form.range.length == 2) {
        const start = form.range[0] + " 00:00:00";
        const end = form.range[1] + " 23:59:59";
        params.start_time = start;
        params.end_time = end;
        if (form.range[0] != form.range[1]) {
          fileName = `${form.range[0]}至${form.range[1]}`;
        }
      }
      if (form.cat) {
        params.cat = form.cat;
        fileName += `${getCatText(form.cat)}`;
      }
      if (form.mem_tablet_region_id) {
        params.mem_tablet_region_id = form.mem_tablet_region_id;
      }
      if (form.mem_tablet_block_id) {
        params.mem_tablet_block_id = form.mem_tablet_block_id;
      }
      if (!isEmpty(form.num)) {
        params.num = form.num;
        fileName += form.num;
      }
      if (!isEmpty(form.keyword)) {
        params.name = form.keyword;
      }
      fileName += "牌位堂供奉订单";
      const keys = Object.keys(params);
      if (keys.length > 0) {
        keys.forEach((k, i) => {
          url += `${i > 0 ? "&" : "?"}${k}=${params[k]}`;
        });
      }
      this.$axios(url, { noTempleFilter: true, responseType: "blob" })
        .then((res) => {
          this.exporting = false;
          downLoadBlobFile(res, fileName);
        })
        .catch(() => {
          this.exporting = false;
        });
    },
    customUrl(form) {
      let res = "";
      if (!isEmpty(form.status)) {
        res += `&filter[status]=${form.status}`;
      }
      if (form.mem_tablet_region_id) {
        res += `&filter[mem_tablet_region_id]=${form.mem_tablet_region_id}`;
      }
      if (form.mem_tablet_block_id) {
        res += `&filter[mem_tablet_block_id]=${form.mem_tablet_block_id}`;
      }
      if (form.range && form.range.length == 2) {
        const start = form.range[0] + " 00:00:00";
        const end = form.range[1] + " 23:59:59";
        res += `&filter[create_time][gte]=${start}&filter[create_time][lt]=${end}`;
      }
      if (!isEmpty(form.keyword)) {
        res += `&filter[or][0][user_name][like]=${form.keyword}&filter[or][1][mobile][like]=${form.keyword}`;
      }
      if (form.num) {
        res += `&filter[num][like]=${form.num}`;
      }
      if (form.status == 1 && form.expire_date) {
        // 已支付
        let now = Math.floor(Date.now() / 1000);
        let end_time = now + 60 * 60 * 24 * form.expire_date;
        res += `&filter[end_time][lte]=${end_time}`;
      }
      if (form.cat) {
        res += `&filter[cat]=${form.cat}`;
      }
      return res;
    },
    dealOrderList(list, fn) {
      list.forEach((item) => {
        dealNicheOrder(item);
        item.catText = getCatText(item.cat);
      });
      fn();
    },
    updateList() {
      this.$refs.dataList.getList();
    },
    showDetail({ item }) {
      this.$store.commit("setDetail", { type: "tabletOrder", obj: item });
      this.$router.push({
        name: "TabletOrderDetail",
        params: { id: item.id },
      });
    },
    cancelOrder(item) {
      this.$confirm({
        title: "提示",
        content: `确定取消此订单吗？`,
        onOk: () => {
          this.$axios({
            url: `/admin/memorial-tablet-order/${item.id}`,
            method: "PATCH",
            data: {
              status: 3,
            },
          }).then(() => {
            this.$message.success("已取消");
            this.updateList();
          });
        },
      });
    },
    // renewal(order) {
    //   this.$store.commit("setNicheOrder", order);
    //   this.$router.push({
    //     name: "NicheOrderCreate",
    //     query: { select: order.buddhist_niche_id, o_id: order.id },
    //   });
    // },
    refundOrder(item) {
      if (item.cat == 2) {
        this.$confirm({
          title: "温馨提示",
          content: "确认退款吗？",
          onOk: () => {
            this.$axios({
              url: `/admin/memorial-tablet-order/${item.id}`,
              method: "PATCH",
              data: {
                status: 4,
              },
              noTempleFilter: true,
            }).then(() => {
              this.$message.success("退款成功");
              this.updateList();
            });
          },
        });
      } else {
        this.refundCash(item);
      }
    },
    refundCash(item) {
      let price = item.price / 100;
      this.$confirm({
        title: "确认退款金额",
        content: (
          <a-input
            v-model={price}
            disabled={true}
            placeholder="请输入退款金额"
            style="width: 100%"
          />
        ),
        okText: "退款",
        onOk: () => {
          let error = "";
          price = Math.round(price * 100);
          if (price <= 0) {
            error = "退款金额必须大于0";
          } else if (price > item.price) {
            error = "退款金额不能超过订单总金额";
          }
          if (error) {
            this.$message.warning(error);
          } else {
            this.$axios({
              url: "/admin/memorial-tablet-order/refund",
              method: "POST",
              data: {
                refund_fee: price,
                order_num: item.order_num,
              },
              noTempleFilter: true,
            }).then((res) => {
              if (res.error == 0 || res.code == 0) {
                this.$message.success("退款成功");
                this.updateList();
              } else {
                this.$message.error(res.msg || "退款失败");
              }
            });
          }
        },
      });
    },
  },
};
</script>

<style scoped></style>
